export default "__VITE_ASSET__eb302f9f__"